// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const ColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 8px;
`

export const ColumnWrapper = styled.div`
  background: ${colors.gray200};
  position: relative;
  padding: 20px;
  border-radius: 4px;
  > svg {
    height: 22px !important;
  }

  > div:last-child {
    margin-top: 20px;
  }
`
